import { configuration } from '../../../../../app/common-reducers.js';
import { facetOptionsReducer as facetOptions } from '../../../../../features/facet-options/facet-options-slice.js';
import { deselectAllFacetValues } from '../../../../../features/facets/facet-set/facet-set-actions.js';
import { registerDateFacet, } from '../../../../../features/facets/range-facets/date-facet-set/date-facet-actions.js';
import { executeToggleDateFacetExclude, executeToggleDateFacetSelect, } from '../../../../../features/facets/range-facets/date-facet-set/date-facet-controller-actions.js';
import { dateFacetSetReducer as dateFacetSet } from '../../../../../features/facets/range-facets/date-facet-set/date-facet-set-slice.js';
import { searchReducer as search } from '../../../../../features/search/search-slice.js';
import { selectActiveTab } from '../../../../../features/tab-set/tab-set-selectors.js';
import { loadReducerError } from '../../../../../utils/errors.js';
import { determineFacetId } from '../../_common/facet-id-determinor.js';
import { assertRangeFacetOptions } from '../core-range-facet-utils.js';
import { buildCoreRangeFacet } from '../headless-core-range-facet.js';
import { buildDateRange, } from './date-range.js';
import { validateDateFacetOptions, } from './headless-date-facet-options.js';
export { buildDateRange };
/**
 * Creates a `DateFacet` controller instance.
 *
 * @param engine - The headless engine.
 * @param props - The configurable `DateFacet` controller properties.
 * @returns A `DateFacet` controller instance.
 *
 * @group Controllers
 * @category DateFacet
 */
export function buildCoreDateFacet(engine, props) {
    if (!loadDateFacetReducers(engine)) {
        throw loadReducerError;
    }
    assertRangeFacetOptions(props.options, 'buildDateFacet');
    const dispatch = engine.dispatch;
    const facetId = determineFacetId(engine, props.options);
    const tabs = props.options.tabs ?? {};
    const activeTab = selectActiveTab(engine.state.tabSet);
    const options = {
        currentValues: [],
        ...props.options,
        facetId,
        tabs,
        activeTab,
    };
    validateDateFacetOptions(engine, options);
    dispatch(registerDateFacet(options));
    const rangeFacet = buildCoreRangeFacet(engine, {
        facetId,
        getRequest: () => engine.state.dateFacetSet[facetId].request,
    });
    return {
        ...rangeFacet,
        toggleSelect: (selection) => dispatch(executeToggleDateFacetSelect({ facetId, selection })),
        toggleSingleSelect: function (selection) {
            if (selection.state === 'idle') {
                dispatch(deselectAllFacetValues(facetId));
            }
            this.toggleSelect(selection);
        },
        toggleExclude: (selection) => dispatch(executeToggleDateFacetExclude({ facetId, selection })),
        toggleSingleExclude: function (selection) {
            if (selection.state === 'idle') {
                dispatch(deselectAllFacetValues(facetId));
            }
            this.toggleExclude(selection);
        },
        get state() {
            return rangeFacet.state;
        },
    };
}
function loadDateFacetReducers(engine) {
    engine.addReducers({ configuration, search, dateFacetSet, facetOptions });
    return true;
}
